import clsx from 'clsx'
import React from 'react'

import { SOCIAL_MEDIA } from '../../constants/social'
import { ThemeIcon } from '../'

import './SocialMediaIcons.scss'

const SocialMediaIcons = ({ className }) => {
   const renderSocialMediaIcons = () =>
      SOCIAL_MEDIA.map(social => (
         <ThemeIcon
            key={social.platform}
            className="SocialMediaIcons__platform"
            name={social.platform}
            size={24}
         />
      ))

   return (
      <div className={clsx('SocialMediaIcons', className)}>
         {renderSocialMediaIcons()}
      </div>
   )
}

export default SocialMediaIcons
